export * from './Booking'
export * from './Cart'
export * from './CartSoldProduct'
export * from './InformationsReservationDto'
export * from './Pay3dSecureDto'
export * from './PayDto'
export * from './Player'
export * from './PostBookingsDto'
export * from './Recap'
export * from './RecapBooking'
export * from './RecapProduct'
export * from './SpecialPrice'

enum ShoppingCartStep {
  BASKET = 'basket',
  PRICING = 'pricing',
  VOUCHER = 'voucher',
  PAYMENT = 'payment',
  CONFIRMATION = 'confirmation',
}

enum GolfAvailabilitiesStatus {
  IDLE = 'idle',
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  ERROR = 'error',
}

enum PaymentStatus {
  ACCEPTED = 'ACCEPTED',
  REFUSED = 'REFUSED',
  SLOT_UNAVAILABLE = 'SLOT_UNAVAILABLE',
  ERROR = 'ERROR',
  IDLE = 'IDLE',
}

export {
  PaymentStatus,
  GolfAvailabilitiesStatus,
  ShoppingCartStep,
}
